export default __webpack_public_path__ + "static/media/1.60f7032e.jpeg";